export default __webpack_public_path__ + "static/media/reread_task.05770d33.svg";